// CSS
import "../../general.css";
import "../newStudentForm.css";

// React
import { useState, useEffect } from "react";

// Bootstrap
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

// Icons
import {
  FiUser,
  FiCalendar,
  FiMapPin,
  FiHash,
  FiCamera,
  FiDatabase,
} from "react-icons/fi";



// Select
import Select from "react-select";

// DatePicker
import DatePicker from "react-datepicker";
import "../../../styles/react-datepicker.css";
import { he } from "date-fns/locale";





function isValidID(idNumber) {
  // Check if the input is a string and has exactly 9 digits
  if (typeof idNumber !== "string" || idNumber.length !== 9) {
    return false;
  }
  return true;
}

function StudentDetailsPhase(props) {
  const setProgress = props.setProgress;
  const newStudentData = props.newStudentData;
  const setNewStudentData = props.setNewStudentData;
  const studentPhoto = props.studentPhoto;
  const setStudentPhoto = props.setStudentPhoto;
  const groupData = props.groupData;
  const userField = props.userField;

  // Form States
  const [personalName, setPersonalName] = useState(
    newStudentData.personalName ? newStudentData.personalName : ""
  );
  const [personalNameTouched, setPersonalNameTouched] = useState(false);
  const [personalNameValid, setPersonalNameValid] = useState(false);

  const [familyName, setFamilyName] = useState(
    newStudentData.familyName ? newStudentData.familyName : ""
  );
  const [familyNameTouched, setFamilyNameTouched] = useState(false);
  const [familyNameValid, setFamilyNameValid] = useState(false);

  const [IDnumber, setIDnumber] = useState(
    newStudentData.IDnumber ? newStudentData.IDnumber : ""
  );
  const [IDnumberTouched, setIDnumberTouched] = useState(false);
  const [IDnumberValid, setIDnumberValid] = useState(false);

  const [address, setAddress] = useState(
    newStudentData.address ? newStudentData.address : ""
  );
  const [addressTouched, setAddressTouched] = useState(false);
  const [addressValid, setAddressValid] = useState(false);

  // For Martial Arts Coaches
  const [beltLevel, setBeltLevel] = useState(
    newStudentData?.specialFields?.beltLevel
      ? newStudentData?.specialFields?.beltLevel
      : "K10"
  );
  const [weightKG, setWeightKG] = useState(
    newStudentData?.specialFields?.weightKG
      ? newStudentData?.specialFields?.weightKG
      : ""
  );
  const [weightKGTouched, setWeightKGTouched] = useState(false);
  const [weightKGValid, setWeightKGValid] = useState(false);

  // For Ball Games Coaches and Dance Coaches
  const [shirtSize, setShirtSize] = useState(
    newStudentData?.specialFields?.shirtSize
      ? newStudentData?.specialFields?.shirtSize
      : "S"
  );
  const [pantsSize, setPantsSize] = useState(
    newStudentData?.specialFields?.pantsSize
      ? newStudentData?.specialFields?.pantsSize
      : "32"
  );

  // Birthday state
  const [birthDate, setBirthDate] = useState(
    newStudentData.birthYear
      ? new Date(
        parseInt(newStudentData.birthYear),
        parseInt(newStudentData.birthMonth) - 1, // Month is 0-indexed in Date constructor
        parseInt(newStudentData.birthDay)
      )
      : null
  );
  const [birthDateTouched, setBirthDateTouched] = useState(false);
  const [birthDateValid, setBirthDateValid] = useState(false);

  const [isBoy, setIsBoy] = useState(
    newStudentData.isBoy ? newStudentData.isBoy : true
  );

  const genderOptions = [
    { value: true, label: "זכר", icon: "👦" },
    { value: false, label: "נקבה", icon: "👧" },
  ];



  // Helper function to validate all fields
  const validateFields = () => {
    if (personalNameTouched) {
      setPersonalNameValid(personalName.trim().length > 0);
    }

    if (familyNameTouched) {
      setFamilyNameValid(familyName.trim().length > 0);
    }

    if (IDnumberTouched) {
      setIDnumberValid(isValidID(IDnumber));
    }

    if (addressTouched) {
      setAddressValid(address.trim().length > 0);
    }

    if (birthDateTouched) {
      setBirthDateValid(birthDate !== null);
    }

    if (userField === "martial_arts" && weightKGTouched) {
      setWeightKGValid(weightKG.trim().length > 0);
    }
  };

  // Validate fields on initial render
  useEffect(() => {
    // If there's pre-filled data, mark the fields as touched and validate them
    if (newStudentData.personalName) {
      setPersonalNameTouched(true);
      setPersonalNameValid(personalName.trim().length > 0);
    }
    if (newStudentData.familyName) {
      setFamilyNameTouched(true);
      setFamilyNameValid(familyName.trim().length > 0);
    }
    if (newStudentData.IDnumber) {
      setIDnumberTouched(true);
      setIDnumberValid(isValidID(IDnumber));
    }
    if (newStudentData.address) {
      setAddressTouched(true);
      setAddressValid(address.trim().length > 0);
    }
    if (newStudentData.birthYear) {
      setBirthDateTouched(true);
      setBirthDateValid(birthDate !== null);
    }
    if (newStudentData?.specialFields?.weightKG) {
      setWeightKGTouched(true);
      setWeightKGValid(weightKG.trim().length > 0);
    }
  }, []);

  // Validate fields whenever any input changes
  useEffect(() => {
    validateFields();
  }, [
    personalName,
    familyName,
    IDnumber,
    address,
    birthDate,
    weightKG,
    userField,
    personalNameTouched,
    familyNameTouched,
    IDnumberTouched,
    addressTouched,
    birthDateTouched,
    weightKGTouched,
  ]);

  const handlePhotoUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setStudentPhoto(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDateChange = (date) => {
    setBirthDate(date);
    setBirthDateValid(date !== null);
  };

  return (
    <div className="student-details-phase phase-transition">
      <style>{`
        .react-datepicker {
          direction: rtl;
          text-align: right;
        }
        .react-datepicker__header {
          direction: rtl !important;
          text-align: center !important;
        }
        .react-datepicker__current-month {
          direction: rtl !important;
          text-align: center !important;
          unicode-bidi: plaintext !important;
          width: 100%;
          display: block;
          font-weight: bold;
        }
        /* Move the clear (X) button to the left in RTL */
        .react-datepicker__close-icon {
          right: auto !important;
          left: 8px !important;
        }
        /* Add padding to the left of the input so text doesn't overlap the X */
        .react-datepicker__input-container input {
          padding-left: 32px !important;
          padding-right: 8px !important;
        }
        /* Hide the day names row completely */
        .react-datepicker__day-names {
          display: none !important;
        }
        /* Remove hover effects from the clear button */
        .react-datepicker__close-icon:hover {
          background-color: inherit !important;
          border-color: inherit !important;
          color: inherit !important;
          transform: none !important;
        }
        /* Use native date input on mobile devices */
        @media (max-width: 768px) {
          .react-datepicker-wrapper {
            display: none !important;
          }
          .react-datepicker__input-container input {
            display: none !important;
          }
        }

      `}</style>
      <h2 className="text-center mb-4">פרטי החניך</h2>

      <div className="photo-upload-section mb-4">
        <label htmlFor="photo-upload" className="photo-upload">
          {studentPhoto ? (
            <img src={studentPhoto} alt="Student" className="photo-preview" />
          ) : (
            <div className="upload-placeholder">
              <FiCamera size={40} color="#666" />
              <span className="mt-2">העלה תמונה</span>
            </div>
          )}
        </label>
        <input
          type="file"
          id="photo-upload"
          accept="image/*"
          onChange={handlePhotoUpload}
          style={{ display: "none" }}
        />
      </div>

      <Form className="student-form">
        <div className="form-section">
          <div className="gender-select mb-4">
            <label className="form-label">מגדר*</label>
            <div className="gender-options">
              {genderOptions.map((option) => (
                <div
                  key={option.label}
                  className={`gender-option ${isBoy === option.value ? "active" : ""
                    }`}
                  onClick={() => setIsBoy(option.value)}
                >
                  <span className="gender-icon">{option.icon}</span>
                  <span className="gender-label">{option.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="form-row">
            <Form.Group className="form-group">
              <div className="input-icon-wrapper">
                <FiUser className="input-icon" />
                <Form.Control
                  type="text"
                  placeholder="שם פרטי*"
                  value={personalName}
                  onChange={(e) => {
                    setPersonalName(e.target.value);
                  }}
                  onBlur={() => {
                    setPersonalNameTouched(true);
                    setPersonalNameValid(personalName.trim().length > 0);
                  }}
                  isInvalid={personalNameTouched && !personalNameValid}
                  className="form-control"
                />
              </div>
            </Form.Group>

            <Form.Group className="form-group">
              <div className="input-icon-wrapper">
                <FiUser className="input-icon" />
                <Form.Control
                  type="text"
                  placeholder="שם משפחה*"
                  value={familyName}
                  onChange={(e) => {
                    setFamilyName(e.target.value);
                  }}
                  onBlur={() => {
                    setFamilyNameTouched(true);
                    setFamilyNameValid(familyName.trim().length > 0);
                  }}
                  isInvalid={familyNameTouched && !familyNameValid}
                  className="form-control"
                />
              </div>
            </Form.Group>
          </div>

          <div className="form-row">
            <Form.Group className="form-group">
              <div className="input-icon-wrapper">
                <FiHash className="input-icon" />
                <Form.Control
                  type="text"
                  placeholder="מספר תעודת זהות*"
                  value={IDnumber}
                  maxLength={9}
                  onChange={(e) => {
                    setIDnumber(e.target.value);
                  }}
                  onBlur={() => {
                    setIDnumberTouched(true);
                    setIDnumberValid(isValidID(IDnumber));
                  }}
                  isInvalid={IDnumberTouched && !IDnumberValid}
                  className="form-control"
                />
              </div>
            </Form.Group>

            <Form.Group className="form-group">
              <div className="input-icon-wrapper">
                <FiMapPin className="input-icon" />
                <Form.Control
                  type="text"
                  placeholder="כתובת מגורים*"
                  value={address}
                  onChange={(e) => {
                    setAddress(e.target.value);
                  }}
                  onBlur={() => {
                    setAddressTouched(true);
                    setAddressValid(address.trim().length > 0);
                  }}
                  isInvalid={addressTouched && !addressValid}
                  className="form-control"
                />
              </div>
            </Form.Group>
          </div>

          <div className="form-row">
            <Form.Group className="form-group">
              <Form.Label className="form-label mb-2">תאריך לידה*</Form.Label>
              <div className="input-icon-wrapper">
                <FiCalendar className="input-icon" />
                <DatePicker
                  selected={birthDate}
                  onChange={handleDateChange}
                  showTimeSelect={false}
                  showYearDropdown={true}
                  showMonthDropdown={true}
                  yearDropdownItemNumber={50}
                  scrollableYearDropdown={true}
                  dateFormat="dd/MM/yyyy"
                  className="eventFormInput form-control"
                  placeholderText="בחר תאריך לידה"
                  isClearable
                  autoComplete="off"
                  locale={he}
                  maxDate={new Date()}
                  onBlur={() => {
                    setBirthDateTouched(true);
                    setBirthDateValid(birthDate !== null);
                  }}
                  isInvalid={birthDateTouched && !birthDateValid}
                />
                {/* Native date input for mobile */}
                <input
                  type="date"
                  value={birthDate ? birthDate.toISOString().split('T')[0] : ''}
                  onChange={(e) => {
                    const date = e.target.value ? new Date(e.target.value) : null;
                    handleDateChange(date);
                  }}
                  max={new Date().toISOString().split('T')[0]}
                  className="eventFormInput form-control d-md-none"
                  style={{ direction: "rtl" }}
                />
              </div>
            </Form.Group>
          </div>
        </div>

        {userField === "martial_arts" && (
          <div className="form-section additional-data-section">
            <h3 className="section-title">
              <FiDatabase className="section-icon" />
              נתונים נוספים
            </h3>
            <Form.Group className="form-group mb-3">
              <Form.Label>צבע חגורה (חניכים חדשים לא צריכים לשנות)</Form.Label>
              <Select
                value={{ value: beltLevel, label: beltLevel }}
                onChange={(selectedOption) =>
                  setBeltLevel(selectedOption.value)
                }
                options={[
                  { value: "K10", label: "K10" },
                  { value: "K9", label: "K9" },
                  { value: "K8", label: "K8" },
                  { value: "K7", label: "K7" },
                  { value: "K6", label: "K6" },
                  { value: "K5", label: "K5" },
                  { value: "K4", label: "K4" },
                  { value: "K3", label: "K3" },
                  { value: "K2", label: "K2" },
                  { value: "K1", label: "K1" },
                  { value: "D1", label: "D1" },
                  { value: "D2", label: "D2" },
                  { value: "D3", label: "D3" },
                  { value: "D4", label: "D4" },
                  { value: "D5", label: "D5" },
                  { value: "D6", label: "D6" },
                  { value: "D7", label: "D7" },
                  { value: "D8", label: "D8" },
                  { value: "D9", label: "D9" },
                  { value: "D10", label: "D10" },
                ]}
                menuPlacement="top"
                className="form-control"
              />
            </Form.Group>
            <Form.Group className="form-group mb-0">
              <Form.Label>משקל (ק"ג)</Form.Label>
              <Form.Control
                type="number"
                placeholder="משקל בקילוגרם"
                value={weightKG}
                onChange={(e) => {
                  setWeightKG(e.target.value);
                }}
                onBlur={() => {
                  setWeightKGTouched(true);
                  setWeightKGValid(weightKG.trim().length > 0);
                }}
                isInvalid={weightKGTouched && !weightKGValid}
                className="form-control"
              />
            </Form.Group>
          </div>
        )}

        {userField === "ball_games" && (
          <div className="form-section additional-data-section">
            <h3 className="section-title">
              <FiDatabase className="section-icon" />
              נתונים נוספים
            </h3>
            <Form.Group className="form-group mb-3">
              <Form.Label>מידת חולצה</Form.Label>
              <Select
                value={{ value: shirtSize, label: shirtSize }}
                onChange={(selectedOption) =>
                  setShirtSize(selectedOption.value)
                }
                options={[
                  { value: "XXS", label: "XXS" },
                  { value: "XS", label: "XS" },
                  { value: "S", label: "S" },
                  { value: "M", label: "M" },
                  { value: "L", label: "L" },
                  { value: "XL", label: "XL" },
                  { value: "XXL", label: "XXL" },
                ]}
                menuPlacement="top"
                className="form-control"
              />
            </Form.Group>
            <Form.Group className="form-group mb-0">
              <Form.Label>מידת מכנסיים</Form.Label>
              <Select
                value={{ value: pantsSize, label: pantsSize }}
                onChange={(selectedOption) =>
                  setPantsSize(selectedOption.value)
                }
                options={Array.from({ length: 26 }, (_, i) => {
                  const size = 10 + i * 2;
                  return { value: size.toString(), label: size.toString() };
                })}
                menuPlacement="top"
                className="form-control"
              />
            </Form.Group>
          </div>
        )}

        {!(
          personalNameValid &&
          familyNameValid &&
          IDnumberValid &&
          addressValid &&
          birthDateValid
        ) && (
            <div className="validation-message">יש למלא את כל השדות הנדרשים</div>
          )}
        <div className="form-actions">
          <Button
            variant="secondary"
            className="btn btn-secondary"
            onClick={() => {
              setProgress(2);
            }}
          >
            חזור
          </Button>
          <Button
            variant="primary"
            className={`btn btn-primary ${!(
              personalNameValid &&
              familyNameValid &&
              IDnumberValid &&
              addressValid &&
              birthDateValid
            )
              ? "btn-disabled"
              : ""
              }`}
            onClick={() => {
              const year = birthDate ? birthDate.getFullYear().toString() : "";
              const month = birthDate ? (birthDate.getMonth() + 1).toString().padStart(2, "0") : "";
              const day = birthDate ? birthDate.getDate().toString().padStart(2, "0") : "";
              let specialFields = {};
              if (userField === "martial_arts") {
                specialFields.weightKG = weightKG;
                specialFields.beltLevel = beltLevel;
              }
              if (userField === "ball_games") {
                specialFields.shirtSize = shirtSize;
                specialFields.pantsSize = pantsSize;
              }
              setNewStudentData({
                personalName: personalName,
                familyName: familyName,
                birthYear: year,
                birthMonth: month,
                birthDay: day,
                isBoy: isBoy,
                IDnumber: IDnumber,
                address: address,
                specialFields: specialFields,
              });
              setProgress(4);
            }}
            disabled={
              !(
                personalNameValid &&
                familyNameValid &&
                IDnumberValid &&
                addressValid &&
                birthDateValid
              )
            }
          >
            המשך
          </Button>
        </div>
      </Form>
    </div>
  );
}

export default StudentDetailsPhase;
